import script from "./FooterCountries.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterCountries.vue?vue&type=script&lang=ts&setup=true"

import "./FooterCountries.vue?vue&type=style&index=0&id=e2c3864c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c3864c"]])

export default __exports__